module.exports = __webpack_public_path__ + "img/Card2.2549048a.jpg";